import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from '@eika/input';

import { useWatchError } from '@/domain/app';
import { useTranslations } from '@/domain/translations';
import { KbPaymentForm } from '@/pages/transactions/components/KbTransactions/components/PaymentForm/PaymentSchema';

import { V4Footer } from '../Footer';

import './SelectPayee.scss';

interface Props {
    onClose(): void;
}

export const SelectPayee: React.FC<Props> = ({ onClose }) => {
    const t = useTranslations();
    const methods = useFormContext();
    const error = useWatchError<KbPaymentForm>('payeeAccountNumber', 'pay.validation.payeeAccountNumber.required');
    const errorName = useWatchError<KbPaymentForm>('payeeName', 'pay.validation.payeeName.required');

    const handleSubmit = async () => {
        const valid = await methods.trigger('payeeAccountNumber');
        const validName = await methods.trigger('payeeName');

        if (valid && validName) {
            onClose();
        }
    };

    return (
        <div className="select-receiver-form__container">
            <div className="select-receiver-form__search-field">
                <Input
                    placeholder={t.pay.payeeModalNamePlaceholder}
                    label={t.pay.payeeModalNameLabel}
                    className="select-receiver-form__search-input"
                    maxLength={35}
                    error={errorName}
                    {...methods.register('payeeName')}
                />
                <Input
                    placeholder={t.pay.payeeModalAccountNumberLabel}
                    label={t.pay.payeeModalAccountNumberLabel}
                    inputMode="numeric"
                    className="select-receiver-form__search-input"
                    error={error}
                    {...methods.register('payeeAccountNumber')}
                />
            </div>

            <V4Footer onCancel={onClose} next={handleSubmit} />
        </div>
    );
};
